import { combineReducers, configureStore } from '@reduxjs/toolkit';
import {
  useSelector as rawUseSelector,
  TypedUseSelectorHook,
  useDispatch as useDispatchRedux
} from 'react-redux';
import { persistReducer, persistStore } from 'redux-persist';
import authSlice from './slices/auth';
import storage from 'redux-persist/lib/storage';

const persistCfg = {
  key: 'root',
  storage,
  blacklist: [],
  whitelist: ['auth']
};

const rootReducer = combineReducers({
  auth: authSlice
});

// Middleware: Redux Persist Persisted Reducer
const persistedReducer = persistReducer(persistCfg, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) => {
    const middlewares = getDefaultMiddleware({ serializableCheck: false });
    // If dev mode, add logger
    if (process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line @typescript-eslint/no-var-requires
      const { logger } = require('redux-logger');
      middlewares.push(logger);
    }
    return middlewares;
  }
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppStore = typeof store;
export type AppDispatch = typeof store.dispatch;
export const useDispatch = () => useDispatchRedux<AppDispatch>(); // Export a hook that can be reused to resolve types
export const useSelector: TypedUseSelectorHook<RootState> = rawUseSelector;
